import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import MuiButton from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import { useThemeExtension } from '../ThemeExtension/index.js';
import buttonTheme from './Button.theme.js';

// by default button should show Contained variant
/**
 * https://mui.com/api/button/
 */
const Button = (_a) => {
    var { children, dataAnalytics = '', dataE2e = '', dataTestId = '', name = '', // name should be unique for the button in the document
    variant = 'contained' } = _a, props = __rest(_a, ["children", "dataAnalytics", "dataE2e", "dataTestId", "name", "variant"]);
    // What about this? The types are so complex that if we don't cast `as object`, we get a wild TypeScript error.
    // We trust that this is safe because it's been validated by the input types for the component.
    const finalProps = name ? Object.assign({ id: name }, props) : props;
    const extendedTheme = useThemeExtension();
    return (jsx(ThemeProvider, Object.assign({ theme: (extendedTheme === null || extendedTheme === void 0 ? void 0 : extendedTheme.Button) || buttonTheme }, { children: jsx(MuiButton, Object.assign({ "data-analytics": dataAnalytics, "data-e2e": dataE2e, "data-testid": dataTestId, variant: variant }, finalProps, { children: children })) })));
};

export { Button as default };
//# sourceMappingURL=Button.js.map
